import { render, staticRenderFns } from "./InvoiceAddressDataEditor.vue?vue&type=template&id=39cba922&scoped=true"
import script from "./InvoiceAddressDataEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./InvoiceAddressDataEditor.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./InvoiceAddressDataEditor.vue?vue&type=style&index=0&id=39cba922&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cba922",
  null
  
)

export default component.exports